// extracted by mini-css-extract-plugin
export default {"navbar":"SideNavBar_navbar__2r+Qn"};